import { SchemaDeSerBuilder, type SchemaDeSer } from "./deser"

export class WatchlistEntry {
  symbol = ""
  instrumentType = ""
}

export class Watchlist {
  id = ""
  name = ""
  groupName = ""
  userId = 0
  orderIndex = 0
  isAutomated = false
  watchlistEntries: WatchlistEntry[] = []
}

const WATCHLIST_ENTRY_DESER: SchemaDeSer<WatchlistEntry> =
  new SchemaDeSerBuilder(WatchlistEntry)
    .ofStrings("symbol", "instrumentType")
    .toDeSer()

export const WATCHLIST_DESER: SchemaDeSer<Watchlist> = new SchemaDeSerBuilder(
  Watchlist
)
  .ofStrings("id", "name", "groupName")
  .ofInt("userId")
  .ofInt("orderIndex")
  .ofBoolean("isAutomated")
  .ofArray("watchlistEntries", WATCHLIST_ENTRY_DESER, WatchlistEntry)
  .toDeSer()
